/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_No_Files_YetInputs */

const en_mobile_no_files_yet = /** @type {(inputs: Mobile_No_Files_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No files yet. Tap “+” to add your first document.`)
};

const es_mobile_no_files_yet = /** @type {(inputs: Mobile_No_Files_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay archivos. Toca “+” para agregar tu primer documento.`)
};

/**
* | output |
* | --- |
* | "No files yet. Tap “+” to add your first document." |
*
* @param {Mobile_No_Files_YetInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_no_files_yet = /** @type {((inputs?: Mobile_No_Files_YetInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_No_Files_YetInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_no_files_yet(inputs)
	return en_mobile_no_files_yet(inputs)
});